import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import WheatPastaProduct from 'models/WheatPastaProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState } from './constants'
import { Controller, useFormContext, ErrorMessage } from 'react-hook-form'
import Switch from 'react-switch'

const WheatPastaNutrition = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSwitch, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const { category, subCategory, WholeWheatFlour, Size } = current
      setPackaging({
        category,
        subCategory,
        WholeWheatFlour: WholeWheatFlour ?? false,
        Size,
      })
    } else if (!updating) {
      setCurrent(WheatPastaProduct)
      setPackaging(packagingInitialState)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>
              I certify that &quot;whole wheat flour&quot; and/or &quot;whole
              durum wheat flour&quot; are the only flours listed in the
              ingredients list. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="WholeWheatFlour"
            id="WholeWheatFlour"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            defaultValue={packaging.WholeWheatFlour}
            rules={{
              validate: WholeWheatFlour => WholeWheatFlour === true,
            }}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="WholeWheatFlour"
              message={
                '⚠ You must certify that this product meets the flour requirement.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default WheatPastaNutrition
